<template>
  <m-base>
    <b-container class="m-layout-content" :fluid="fluid">
      <b-row style="margin-right: 0">
        <b-col style="padding-right: 0">
          <slot></slot>
        </b-col>
      </b-row>
    </b-container>
  </m-base>
</template>

<script>
import MBase from '@/components/layouts/MBase.vue'

export default {
  components: {
    MBase
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    fluid: {
      type: Boolean,
      default: true
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
.side {
  width: 100%;
  height: 200px;
  background-color: $color-background;
}

.title {
  padding-top: 0;
  padding-bottom: 8px;
}

.m-layout-content {
  padding: 1em 32px 1em 16px;
    background: white;
}

@media(max-width: 768px) {
  .m-layout-content {
    padding: 8px 8px 8px 8px;
  }
}


.sample {
  line-height: 28px;
  white-space: nowrap;
}

.header-title {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/MContent.vue